module.exports = __webpack_public_path__ + "static/grad-na-zrnu-soli-ef5937a01a0902457b1f572330b20179.png";